module.exports = __webpack_public_path__ + "img/JURIDICO-thumb.76287b87.png";